import {
  handleResp,
  getURLWithQueryParams,
  getDefaultHeaders,
  extendFetchOptions,
} from "./utils";
import type {
  WrappedCashifyFunction,
  WrappedCashifyPageableQuery,
  GenericResponse,
  Sortable,
} from "./utils";

export interface DeviceBindingService {
  listDeviceRegistration: ReturnType<typeof listDeviceRegistration>;
  getDeviceRegistrationDetail: ReturnType<typeof getDeviceRegistrationDetail>;
  listBindingAuthHistory: ReturnType<typeof listBindingAuthHistory>;
  getBindingAuthHistoryDetail: ReturnType<typeof getBindingAuthHistoryDetail>;
}

export type DeviceBindingProvider = "idenkey";

// Device Binding Registration
export type DeviceBindingRegistrationStatus =
  "PENDING"
  | "BINDING_FAILURE"
  | "ACTIVE"
  | "LOCKED"
  | "DEREGISTERED"
  ;

export interface DeviceBindingRegistrationSearchCriteria extends Sortable {
  id?: number;
  userId?: number;
  provider?: DeviceBindingProvider[];
  registrationId?: string;
  status?: DeviceBindingRegistrationStatus[];
  "createTime.from"?: string;
  "createTime.to"?: string;
  "lastUpdateTime.from"?: string;
  "lastUpdateTime.to"?: string;
  lastUpdateAdmin?: string;
};

export interface DeviceBindingRegistrationDTO {
  id: number;
  tenantId: number;
  userId: number;
  provider: DeviceBindingProvider;
  registrationId: string;
  status: DeviceBindingRegistrationStatus;
  remark?: string;
  createTime: string;
  lastUpdateTime?: string;
  lastUpdateAdmin?: string;
};

// Device Binding Authentication History
export type DeviceBindingAuthenticationStatus =
  "PENDING"
  | "AUTHENTICATED"
  | "REJECTED"
  | "CANCELLED"
  | "TIMEOUT"
  | "FAILURE"
  ;

export interface DeviceBindingAuthenticationHistorySearchCriteria extends Sortable {
  id?: number;
  userId?: number;
  provider?: DeviceBindingProvider[];
  registrationId?: string;
  transactionId?: string;
  status?: DeviceBindingAuthenticationStatus[];
  "createTime.from"?: string;
  "createTime.to"?: string;
  "lastUpdateTime.from"?: string;
  "lastUpdateTime.to"?: string;
  lastUpdateAdmin?: string;
};

export interface DeviceBindingAuthenticationHistoryDTO {
  id: number;
  tenantId: number;
  userId: number;
  provider: DeviceBindingProvider;
  registrationId: string;
  transactionId: string;
  status: DeviceBindingAuthenticationStatus;
  remark?: string;
  createTime: string;
  lastUpdateTime?: string;
  lastUpdateAdmin?: string;
};

export const listDeviceRegistration: WrappedCashifyPageableQuery<DeviceBindingRegistrationSearchCriteria, DeviceBindingRegistrationDTO> = ({ urlPrefix, options }) => {
  return async (queryParams) => {
    let url = getURLWithQueryParams(
      `${urlPrefix}/api/v1/device-binding/registration`,
      queryParams,
    );
    let opts = extendFetchOptions(
      {
        method: "GET",
        headers: getDefaultHeaders(),
      },
      options,
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};

export const getDeviceRegistrationDetail: WrappedCashifyFunction<{ id: number }, GenericResponse<DeviceBindingRegistrationDTO>> = ({ urlPrefix, options }) => {
  return async ({ id }) => {
    let url = `${urlPrefix}/api/v1/device-binding/registration/${id}`;
    let opts = extendFetchOptions(
      {
        method: "GET",
        headers: getDefaultHeaders(),
      },
      options,
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};

export const listBindingAuthHistory: WrappedCashifyPageableQuery<DeviceBindingAuthenticationHistorySearchCriteria, DeviceBindingAuthenticationHistoryDTO> = ({ urlPrefix, options }) => {
  return async (queryParams) => {
    let url = getURLWithQueryParams(
      `${urlPrefix}/api/v1/device-binding/authentication`,
      queryParams,
    );
    let opts = extendFetchOptions(
      {
        method: "GET",
        headers: getDefaultHeaders(),
      },
      options,
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};

export const getBindingAuthHistoryDetail: WrappedCashifyFunction<{ id: number }, GenericResponse<DeviceBindingAuthenticationHistoryDTO>> = ({ urlPrefix, options }) => {
  return async ({ id }) => {
    let url = `${urlPrefix}/api/v1/device-binding/authentication/${id}`;
    let opts = extendFetchOptions(
      {
        method: "GET",
        headers: getDefaultHeaders(),
      },
      options,
    );
    return fetch(url, opts).then((resp) => handleResp(resp));
  };
};
